export const kidsIncentiveBannerSupportedPaths = ['/kids', '/t/kids'];
